module.exports = __webpack_public_path__ + "media/img/email/home_bg-16425dd1e9d7aad9af9b1670a0531c43.jpg";